import type { ConditionalRequestDefinition } from '@/utils/dehydrateRequestData/types';
import { hasHersteller } from '@/features/Sparten/shared/contractDehydration/kfz/conditionalRequestDefinitions';
import { kfzContractDehydrationDefinitions } from '@/features/Sparten/shared/contractDehydration/kfz/contractDehydration';

export const pkwContractDehydrationDefinitions: ConditionalRequestDefinition[] =
  kfzContractDehydrationDefinitions.concat([hasHersteller]);
